import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

/**
 * Defines criteria for transitioning between levels (upgrade or downgrade)
 */
@Entity()
export class ChancenkurveThresholdTransition extends AdornisEntity {
  static override _class = 'ChancenkurveThresholdTransition';

  /**
   * Target level ID to transition to
   */
  @Field(() => String)
  targetLevel: Maybe<string>;

  /**
   * Minimum accuracy percentage (0-100) required for upgrade
   */
  @Field(() => Float)
  minAccuracyPercent: Maybe<number>;

  /**
   * Maximum accuracy percentage (0-100) allowed before downgrade
   */
  @Field(() => Float)
  maxAccuracyPercent: Maybe<number>;

  /**
   * Minimum speed (items per minute) required for upgrade
   */
  @Field(() => Float)
  minSpeed: Maybe<number>;

  /**
   * Maximum speed (items per minute) allowed before downgrade
   */
  @Field(() => Float)
  maxSpeed: Maybe<number>;
}
